import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import {
  selectDisposeLoans,
  selectLoansPagination,
  fetchDisposeLoansActions,
  selectDisposeLoansFilter,
  setDisposeLoansFilterAction,
  selectDisposedAmount,
  clearDisposedAmountActions
} from '../ducks';
import { DisposeLoanList } from '../components';
import { apiCallIds as loanApiCallIds } from '../api';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import Modal from 'antd/lib/modal';
import { currencyFormatter } from '../../../common/utils/helpers';
import { selectToken } from '../../../features/auth/ducks';

const mapStateToProps = state => ({
  disposeLoans: selectDisposeLoans(state),
  disposedAmount: selectDisposedAmount(state),
  filter: selectDisposeLoansFilter(state),
  token: selectToken(state),
  pagination: selectLoansPagination(state),
  isLoading: selectIsInProgress(state, loanApiCallIds.DISPOSE_LOAN) || selectIsInProgress(state, loanApiCallIds.FETCH_DISPOSE_LOANS),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchDisposeLoans: fetchDisposeLoansActions.request,
      setFilter: setDisposeLoansFilterAction,
      clearDisposedAmount: clearDisposedAmountActions,
    },
    dispatch
  ),
});

const defaultFilter = {
  search: '',
  //status: loanStatus.POD,
  allLoans: false,
};

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class DisposeLoanListContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    disposeLoans: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { actions } = this.props;
    console.log(this.props.filter)
    actions.setFilter(defaultFilter);
    //actions.fetchDisposeLoans(defaultFilter);
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.props.pagination.current = pagination.current;
    console.log(this.props.filter)
    this.props.actions.fetchDisposeLoans({
      ...this.props.filter,
      pageNo: pagination.current - 1,
    });
  };

  onFilterChange = filterKey => filterValue => {
    const { filter, actions } = this.props;
    actions.setFilter({
      ...filter,
      [filterKey]: filterValue,
    });
    //actions.fetchDisposeLoans();
  };

  onFilterSearchChange = filterValue => {
    const { actions, filter } = this.props;
    actions.setFilter({
      ...filter,
      search: filterValue,
      status: '',
    });
  };

  onFilterLoansChange = event => {
    const { actions, filter } = this.props;
    actions.setFilter({
      ...filter,
      allLoans: event.target.checked
    });
  }

  onFilterStatusChange = this.onFilterChange('status');

  handleCancel = () => {
    const {actions} = this.props;
    actions.clearDisposedAmount();
  }

  render() {
    const { token, disposeLoans, pagination, filter, isLoading, t, disposedAmount } = this.props;

    return (
      <div id="loanstablediv">
        <h1>{t('Odpredaj pohľadávky')}</h1>
        { disposedAmount && 
          <Modal
              title={t('Výsledok odpredaja pohľadavok')}
              onCancel={this.handleCancel}
              footer={null}
              visible={true}
            >
              <div>
                  Pohľadávky/a bola odpredaná za {currencyFormatter(disposedAmount)}
              </div>
          </Modal>}
        <DisposeLoanList
          token={token}
          loans={disposeLoans}
          pagination={pagination}
          onFilterLoansChange={this.onFilterLoansChange}
          onFilterSearchChange={this.onFilterSearchChange}
          filter={filter}
          onTableChange={this.handleTableChange}
          isLoading={isLoading}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loan-management/containers/DisposeLoanListContainer.js